document.addEventListener('DOMContentLoaded', function () {
    const storeBlock = document.querySelector('.store_block');
    const dealerBlock = document.querySelector('.dealer_block');

    const awStoreList = document.querySelector('.aw_store_list');
    if (storeBlock && awStoreList) {
        storeBlock.appendChild(awStoreList);
    }

    const dealerContents = document.querySelectorAll('.dealer_content');
    if (dealerBlock && dealerContents.length > 0) {
        dealerContents.forEach(function (dealerContent) {
            dealerBlock.appendChild(dealerContent);
        });
    }
});
